module.exports = __webpack_public_path__ + "static/media/stop-bullying-1.1de00cd7.jpeg";